import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const isDashboardRoot = pathname === '/manage_v2_secure_auth' || 
                                pathname === '/manage_v2_secure_auth/' || 
                                pathname === '/superadmin_v2_secure' || 
                                pathname === '/superadmin_v2_secure/';

        const handleScroll = () => {
            if (isDashboardRoot) {
                sessionStorage.setItem(`scrollPos_${pathname}`, window.scrollY.toString());
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [pathname]);

    useEffect(() => {
        const isDashboardRoot = pathname === '/manage_v2_secure_auth' || 
                                pathname === '/manage_v2_secure_auth/' || 
                                pathname === '/superadmin_v2_secure' || 
                                pathname === '/superadmin_v2_secure/';

        const savedPosition = sessionStorage.getItem(`scrollPos_${pathname}`);
        if (isDashboardRoot && savedPosition) {
            // Small timeout to allow React to render the component before scrolling
            setTimeout(() => {
                window.scrollTo(0, parseInt(savedPosition, 10));
            }, 10);
        } else {
            setTimeout(() => window.scrollTo(0, 0), 10);
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
